import { FormikEnhancedStatus } from '@superdispatch/forms';

export interface StatusError {
  isExceeded: boolean;
  isIncorrect: boolean;
  isStatusError: boolean;
}

export function getStatusErrors(
  status: Partial<FormikEnhancedStatus<unknown>>,
): StatusError {
  const payload = (status.payload as Error) || {};
  const message = payload.message || '';
  const isExceeded = message.includes('exceeded');
  const isIncorrect = message.includes('incorrect');

  return {
    isExceeded,
    isIncorrect,
    isStatusError: isExceeded || isIncorrect,
  };
}
